/* @flow */

const { location }: { location: Location } = global;

const isAdmin = () => /admin/.test(location.host);

export default isAdmin;
